import React, { useState, useEffect } from 'react';
import logo from "../../assets/images/register/logo.svg";
import DefaultImageWeb from "../../assets/images/register/signup_web.svg";
import DefaultImageWap from "../../assets/images/register/signup_wap.svg";
import { connect } from "react-redux";
import SetInnerHtml from '../../components/utils/setInnerHtml'
import { getCtaMessaging } from "../../../store/slices/Registration/CommonSlices"
import Cookies from "universal-cookie";
import { createCurrentUrl, getAbsoluteDestinationUrl, certificationPage, deviceType } from "../../utils/registrationUtils"
import Img from '../common/imageWrapper';

const CareersRegisterLeft = (props) => {
    const cookies = new Cookies();
    //to check correct current url
    const subDomainName = window.location.host?.split(".")[0];
    const urlCheck = window.location.href;
    let certificationFormCheck = window.location.search?.includes("ftype=certificationform") ||
        window.location.search?.includes("ftype=certification") || certificationPage(urlCheck);
    const currentUrl = cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.source_destination;
    const sourseDestination = currentUrl ? `${currentUrl}${window.location.search}` : getAbsoluteDestinationUrl();
    //-----------------------------

    useEffect(() => {
        let current_url = sourseDestination || createCurrentUrl();
        props.dispatch(getCtaMessaging({ url: current_url }))
    }, [])

    return (
        <div className='careers_register_left'>
            <div className='careers_register_logo'>
                <img src={logo} alt="careers_register_logo" />
            </div>
            {props.leftSideContent?.context ?
                <div className='careers_register_left_list'>
                    <SetInnerHtml data={props.leftSideContent?.context} />
                </div> : 
                deviceType == "web" ?
                <><div className='left_content_heading'><b>Unlock Your Future with Careers360</b></div>
                <div className='left_content_heading_two'>Register now and get exclusive access to:</div>
                    
                    <ul className='careers_register_left_list'>
                        <li>Exam and admission alerts</li>
                        <li>Mock tests & sample papers</li>
                        <li>100+ Entrance exam preparation e-Books</li>
                        <li>AI-based college/rank prediction tools</li>
                        <li>College and Course guides</li>
                        <li>Large community of like minded students</li>
                        <li>Detailed Webinars and Online Sessions</li>
                        <li>1 on 1 Counselling from experts</li>
                        <div className='left_content_more'>And much more!</div>
                         
                    </ul> </>
                    : 
                    <><div className='left_content_heading'><b>Complete your registration to access:</b></div>
                    <ul className='careers_register_left_list'>
                    <li>Exam & admission alerts</li>
                    <li>Free mock tests</li>
                    <li>Expert study guides</li>
                    <li>College predictor & more</li> 
                    </ul> 
                    </>
                }
            {deviceType == "web" ?
                <Img
                    src={props.leftSideContent?.image_web ? props.leftSideContent?.image_web : DefaultImageWeb}
                    alt="domainImg" onError={(e) => console.log("........error")} fallback={DefaultImageWeb}
                    className="careers_register_domain_img" />
                : 
                <Img
                    src={props.leftSideContent?.image_mobile ? props.leftSideContent?.image_mobile : DefaultImageWap}
                    alt="domainImg" onError={(e) => console.log("........error")} fallback={DefaultImageWap}
                    className="careers_register_domain_img" />
            }
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        leftSideContent: state?.usersCommonData?.ctaMessaging
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CareersRegisterLeft);